var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportUploadDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4C5.22386 4 5 4.22386 5 4.5C5 4.77614 5.22386 5 5.5 5H14.5C14.7761 5 15 4.77614 15 4.5C15 4.22386 14.7761 4 14.5 4H5.5ZM10.3536 6.14645C10.1583 5.95118 9.84171 5.95118 9.64645 6.14645L6.14645 9.64645C5.95118 9.84171 5.95118 10.1583 6.14645 10.3536C6.34171 10.5488 6.65829 10.5488 6.85355 10.3536L9.5 7.70711V15.5C9.5 15.7761 9.72386 16 10 16C10.2761 16 10.5 15.7761 10.5 15.5V7.70711L13.1464 10.3536C13.3417 10.5488 13.6583 10.5488 13.8536 10.3536C14.0488 10.1583 14.0488 9.84171 13.8536 9.64645L10.3536 6.14645Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportUploadDisabled);
export default __webpack_public_path__ + "static/media/supportUploadDisabled.a1865217325b144e81e58d58365cd379.svg";
export { ForwardRef as ReactComponent };